import { useEffect } from 'react'

// custom hook for setting document title on a page
const useDocumentTitle = (title: string) => {
  const pageTitle = title

  useEffect(() => {
    document.title = pageTitle

    return () => {
      document.title = pageTitle
    }
  }, [title, pageTitle])
}

export default useDocumentTitle
